import { ModelBase } from 'store/model-base';
import { ActivityCodes } from 'src/xm/my-account/constants';

export class ReasonCodes extends ModelBase {
    public static storeName: string = 'reasonCodes';

    public codes: ReasonCode[];
    public returnCodes: ReasonCode[];

    public static create<T extends ModelBase>(data: ApiResponse): T {
        data.returnCodes = data.codes.filter((code: ReasonCode) => code.activityCode.toUpperCase() === ActivityCodes.RETURN);

        return super.create<T>(data);
    }
}
